<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <div class="panel__header__left">Update Compliance Information</div>
        </div>
        <div class="panel__header__right"></div>
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <!--beneficiaries list table-->
        <!--transfer loading-->
        <div class="loaderContainer" v-if="isLoading">
          <img src="/static/wave.gif" alt width="32" height="32" />
        </div>

        <transition name="slide-fade">
          <form action="" class="form compliance-form" @submit.prevent="updateComplianceInfo()">
            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Business
                <span>Name</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.business_name" id="business_name" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Business
                <span>Reg No</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.business_reg_number" id="business_reg_number" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Business
                <span>Address</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.business_address" id="business_address" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>State</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.state" id="state" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>City</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.city" id="city" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Business <span>Description</span>
              </label>
              <div class="select form--right">
                <textarea rows="3" class="form__input input" v-model="createObject.business_description" placeholder="E.g. We design and sell bespoke software"></textarea>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="email" class="form__label--span form--left">
                <span>Email</span>
              </label>
              <div class="select form--right">
                <input type="email" name="name" v-model="createObject.email" id="email" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false" />
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>BVN</span>
              </label>
              <div class="input-conjoined form--right">
                <div class="select">
                  <div class="select__input" v-text="(max - createObject.bvn.length)"></div>
                </div>
                <input :maxlength="max" type="text" name="name" v-model="createObject.bvn" id="bvn" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
              <span style="position: absolute; right: 30px"><small>{{ bvnMessage }}</small></span>
            </div>

             <transition class="select form--right" name="slide-fade">
              <div style="padding-left:30%" class="form__input--error--text" v-if="bvnError">
                <p>{{ bvnError }}</p>
              </div>
            </transition>

            <br>

            <div class="form__item">
              <label for="countryCode" class="form__label--span form--left">
                Phone <span>Number</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.phone_number" id="phone_number" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false" />
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>Address</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.address" id="address" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Contact <span>Number</span>
              </label>
              <div class="select form--right">
                <input type="text" name="name" v-model="createObject.contact_number" id="contact_number" class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false"/>
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>Payment Types</span>
              </label>
              <div class="select form" style="margin-left: 10px">
                <div>
                  <input type="checkbox" id="imto" value="Remittances / IMTO" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="imto" class="checkbox__label">Remittances / IMTO</label>
                </div>
                <div>
                  <input type="checkbox" id="purchase" value="Purchases / Bills" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="purchase" class="checkbox__label">Purchases / Bills</label>
                </div>
                <div>
                  <input type="checkbox" id="loan" value="Loans" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="loan" class="checkbox__label">Loans</label>
                </div>
                <div>
                  <input type="checkbox" id="salary" value="Salaries" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="salary" class="checkbox__label">Salaries</label>
                </div>
                <div>
                  <input type="checkbox" id="vendor" value="Vendor Payments / Settlements" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="vendor" class="checkbox__label">Vendor Payments / Settlements</label>
                </div>
                <div>
                  <input type="checkbox" id="agency" value="Agency Banking" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="agency" class="checkbox__label">Agency Banking</label>
                </div>
                <div>
                  <input type="checkbox" id="other" value="Others" class="checkbox__input" v-model="selectedCurrencies">
                  <label for="other" class="checkbox__label">Others</label>
                </div>
              </div>
            </div>

            <div class="form__item" v-show="selectedCurrencies.includes('Remittances / IMTO')">
              <label for="beneficiarySource" class="form__label--span form--left">
                MTO
                <span>License</span>
              </label>
              <div class="select form--right">
                <input ref="mto_doc" type="file" id="file1"
                accept="image/*,.pdf"
                v-on:change="fileUpload('mto_doc')" />
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                CAC
                <span>Documentation</span>
              </label>
              <div class="select form--right">
                <input ref="cac_doc" type="file" id="file2"
                accept="image/*,.pdf"
                v-on:change="fileUpload('cac_doc')" />
              </div>
            </div>

            <br>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                <span>Shareholders</span>
              </label>
              <div class="select form--right">
                <input ref="shareholders_doc" type="file" id="file3"
                accept="image/*,.pdf"
                v-on:change="fileUpload('shareholders_doc')" />
              </div>
            </div>

            <div class="form__item">
              <label for="beneficiarySource" class="form__label--span form--left">
                Means of Identification
              </label>
              <div class="select form--right">
                <input ref="identification_doc" type="file" id="file4"
                accept="image/*,.pdf"
                v-on:change="fileUpload('identification_doc')" />
              </div>
            </div>

            <div id="snackbar"></div>
            <br>
            <div class="form__item">
              <button
                id="submitButton"
                type="submit"
                class="btn btn--primary btn--block beneficiary_submit"
              >
                Update Compliance Information
              </button>
            </div>
          </form>
        </transition>
      </div>
    </div>

    <div class="modal fade" id="PhoneVerification" tabindex="-1" role="dialog" aria-labelledby="PhoneVerification">
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--sm" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <!-- <span class="time-icon">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                  id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;" xml:space="preserve" class="icon--sm">
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000" class="active-path" data-old_color="#576ae6" fill="#576ae6"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span> -->
              Phone Number Verification
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path fill="#C0C6D8" fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z">
                </path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body">
            <br>
            <div class>
              <form class="form disburse-form" @submit.prevent="handleOTP()">
                 <div style="display: flex; flex-direction: column; align-items: center">
                     <p>{{ bvnResponse.description }}</p>
                     <br>
                     <strong>{{ bvnResponse.phoneNumber }}</strong>
                     <br>
                 </div>
                <div class="form__item">
                    <input type="text" name="name" v-model="otp" id="otp"
                      class="form__input input" data-vv-id="1" aria-required="true" aria-invalid="false" />

                    <!-- </div> -->
                  </div>
                  <br>
                  <div id="otp-snackbar" class="error"></div>
                  <br>
                <button :disabled="!otp || otp.length < 4" type="submit" id="otpSubmit" class="btn btn--primary btn--block beneficiary_submit">
                  Verify
                </button>
              </form>
              <br>
            </div>
          </div>
          <!-- <div class="modal__footer">
            <button v-if="true" class="btn btn--primary" id="submitbtn"
              @click="handleBankList(selectedCountry, 1)">Download</button>
          </div> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PaginationView from "@/components/partials/PaginationView";
import ModalTemplate from "@/components/partials/ModalTemplate.vue";
import {verifiedService, getComplianceInfo} from '../../utils/verified/verifiedServices'
import { foundBvn, validateBvnOtp, validateImageMagicNumber } from "../../utils/helpers/utilitiesService";
import { uploadFile } from "../../utils/upload/fileUpload"



export default {
  created() {
    // this.getComplianceInfo();
    this.$store.state.authUser.paymentSelected = [];
  },

  data() {
    return {
      isLoading: false,
      createObject: {
        "business_name": "",
        "business_address": "",
        "mto_doc": "",
        "cac_doc": "",
        "business_reg_number": "",
        "shareholders_doc": "",
        "bvn": "",
        "identification_doc": "",
        "address": "",
        "city": "",
        "state": "",
        "email": "",
        "phone_number": "",
        "business_description": "",
        "contact_number": "",
      },
      bvnError: false,
      bvnMessage: null,
      bvnDetails: null,
      bvnResponse: {
        description: null,
        phoneNumber: null
      },
      max: 11,
      otp: null,
      ref: null,
    };
  },
  components: {
    pagination: PaginationView,
    "modal-template": ModalTemplate,
  },
  watch: {
    'createObject.bvn': function() {
      let submitBtn = document.getElementById("submitButton");
      submitBtn.disabled = true;

      this.bvnDetails = null;


      if (this.createObject.bvn.length === 11) {
        //check if email is valid
        if (!this.createObject.email) {
          this.bvnError = 'Invalid Email';
          this.bvnMessage = null;
          return;
        }
        this.bvnMessage = "Checking ...";
        foundBvn(this.createObject.bvn, this.createObject.email)
          .then((resp) => {
            if (resp.data && resp.data.data && resp.data.data.phoneNumber) {
              submitBtn.disabled = false;
              this.bvnMessage = 'done';
              this.bvnError = null;

              if(resp.data.data.pendingValidation) {
                this.ref = resp.data.data.ref;
                this.bvnResponse.description = resp.data.data.description;
                this.bvnResponse.phoneNumber = resp.data.data.phoneNumber;
                $('#PhoneVerification').modal('show');
              }

            }
          })
          .catch((err) => {
            this.bvnError = 'Invalid Bvn Details';
            this.bvnMessage = null;

          });
      } else {
        this.bvnMessage = 'pending';
        submitBtn.disabled = true;
      }

      if (this.createObject.bvn.length === 0) {
        this.bvnError = false;
        this.bvnMessage = null;
        submitBtn.disabled = false;
      }

    }
  },
  computed: {
    selectedCurrencies:{
      get(){
        return this.$store.state.authUser.paymentSelected
      },
      set(value){
        this.$store.commit('updateSelectedPaymentType', value);
      }

    },
  },
  methods: {
    handleOTP() {
      validateBvnOtp(this.otp, this.ref).then((resp) => {
        console.log(resp)
        if (resp.data && resp.data.data && resp.data.status === 'success') {
          // this.showSnackbar('BVN Verified');
          $('#PhoneVerification').modal('hide');
          this.bvnDetails = resp.data.data.firstName + ' ' + resp.data.data.middleName + ' ' + resp.data.data.lastName;
        }
      }).catch((err) => {
        this.showOTPSnackbar('Invalid OTP');
        console.log(err);
      });
    },
    async fileUpload(name) {
      const maxAllowedSize = 1024*10000
      const file = this.$refs[name].files[0];
      if (file.size > maxAllowedSize) {
        return this.showSnackbar("maximum file size exceeded");
      }

      if (file) {
        const fileType = file.type;
        if (!fileType.startsWith('image') && !fileType.endsWith('pdf')) {
            return this.showSnackbar('Invalid file type. Please select an image.')
        }
        try{
            const isValidMagicNumber = await validateImageMagicNumber(file);
            if(!isValidMagicNumber){
                this.$refs[name].value = "";
                return this.showSnackbar("Invalid file type");
            }
        } catch (error){
            return this.showSnackbar("An error occurred during validation.");
        }
      }
      this.createObject[name] = this.$refs[name].files[0];
    },
    updateComplianceInfo() {
      // might need to save old data, so i know to only send those fields that were edited
      const promise = [];
      const data = {};

      let submitBtn = document.getElementById("submitButton");
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Processing..";

      Object.keys(this.createObject).forEach((v) => {
        const current = v.replaceAll('_', '-');
        if (this.createObject[v] !== "" && this.createObject[v] !== undefined) data[current] = this.createObject[v];
      });

      Object.values(data).forEach((file) => {
        if (file && file.name) {
          promise.push(uploadFile(file, file.name))
        //   promise.push(client.upload(file))
        }
      });

      Promise.all(promise)
      .then(async (response) => {
        const verifiedPromise = [];

        response.forEach((response, index) => {
          Object.keys(data).forEach((fileIndex) => {
            const current_file = data[fileIndex];
            if (response.data.url && response.data.filename === current_file.name) {
              data[fileIndex] = response.data.url;
            }
          });
        });
        if (this.$store.state.authUser.paymentSelected.length > 0) data['payment-types'] = JSON.stringify(this.$store.state.authUser.paymentSelected);

        for (const key in data) {
          verifiedPromise.push(await verifiedService(data[key], key, this.$cookies.get('userEmail')));
        }

        return verifiedPromise;
      })
      .then((returnedResponse) => {
        this.showSnackbar("Compliance Documents have been updated");
      })
      .catch((error) => {
        console.log(error);
        const message = (error.response && error.response.data) ? error.response.data.message : 'There was an error, please try again'.
        this.showSnackbar(message);
      });
    },

    getComplianceInfo() {
      getComplianceInfo()
      .then((response) => {
        const obj = {};
        if (response.data.data) {
          Object.keys(response.data.data).forEach((v) => {
            const current = v.replaceAll('-', '_');
            obj[current] = response.data.data[v];
          });
          this.createObject = obj;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    showSnackbar(text) {
      let snackbar = document.getElementById("snackbar");
      let submitBtn = document.getElementById("submitButton");
      snackbar.innerHTML = text;
      snackbar.className = "show";

      setTimeout(function() {
        snackbar.className = snackbar.className.replace("show", "");
        submitBtn.disabled = false;
        submitBtn.innerHTML = "Update Compliance Information";
      }, 5000);
    },
    showOTPSnackbar(text) {
      let snackbar = document.getElementById("otp-snackbar");
      let submitBtn = document.getElementById("otpSubmit");
      snackbar.innerHTML = text;
      snackbar.className = snackbar.className + " show";

      setTimeout(function() {
        snackbar.className = snackbar.className.replace("show", "");
        submitBtn.disabled = false;
        submitBtn.innerHTML = "Verify";
      }, 5000);
    }

  },
};
</script>
<style scoped>
#snackbar, #otp-snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: deepskyblue;
  color: white;
  padding: 5px;
  text-align: center;
}
#snackbar.error, #otp-snackbar.error {
  background-color: red;
}
#snackbar.show, #otp-snackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/compliance.vue